import { render, staticRenderFns } from "./forward-list.vue?vue&type=template&id=b5928744&scoped=true&"
import script from "./forward-list.vue?vue&type=script&lang=js&"
export * from "./forward-list.vue?vue&type=script&lang=js&"
import style0 from "./forward-list.vue?vue&type=style&index=0&id=b5928744&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5928744",
  null
  
)

export default component.exports